import type { TurnEvidencePayload } from '@Application/Beneficiaries/Documents/Actions/documentFetched';
import LabeledValueView from '@UI/Store/Shared/Views/LabeledValueView';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * A citation from an interview transcript, `type: 'turn'` discriminant. `interviewId` is a
 * relation, resolved against `interviewsStore.interviews` by the reader — never nested further.
 */
class TurnEvidenceView {
	readonly type: 'turn';
	readonly interviewId: number;
	readonly turnPosition: number;
	readonly quote: string;
	readonly speakerLabel: string | null;
	readonly speakerKind: LabeledValueView | null;
	readonly startSecond: number | null;
	readonly endSecond: number | null;

	constructor(payload: TurnEvidencePayload) {
		this.type = 'turn';
		this.interviewId = payload.interview.id;
		this.turnPosition = payload.turnPosition;
		this.quote = payload.quote;
		this.speakerLabel = payload.speakerLabel;
		this.speakerKind = payload.speakerKind === null ? null : new LabeledValueView(payload.speakerKind);
		this.startSecond = payload.startSecond;
		this.endSecond = payload.endSecond;

		Object.freeze(this);
	}
}

export default TurnEvidenceView;
